<div #footerContainer class="section-container plantlife-empty-footer"></div>
